import { DependencyList, useCallback, useEffect, useState } from "react";

import { v4 as uuidv4 } from "uuid";

const useHtmlCallback = (callback: (...args: any[]) => void, deps: DependencyList): string => {
  const [callbackName] = useState<string>(`__mmc_callback_${uuidv4().replace(/-/g, "")}`);
  // Disabling next line because all deps are required and should be provided from the outside
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handler = useCallback(callback, deps);
  useEffect(() => {
    // @ts-ignore
    window[callbackName] = handler;
    return () => {
      // @ts-ignore
      delete window[callbackName];
    };
  }, [callbackName, handler]);
  return callbackName;
};

export default useHtmlCallback;
